import { useMutation } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { sessionStore } from '../../store/sessionStore';
import toast from 'src/utils/appAlert';

interface UpdateProfilePayload {
  uid: string;
  data: any; // The section data to update
  oldAvatarUrl?: string; // Optional old avatar url for deletion
  oldVideoUrl?: string; // Optional old intro video url for deletion
  introductionVideoSize?: number;
  introductionVideoDuration?: number;
}

export const updateTrainerProfile = async (payload: UpdateProfilePayload) => {
  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_UPDATE_PROFILE}`;

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to update profile');
  }

  return response.json();
};

export function useUpdateTrainerProfile() {
  const updateStoreProfile = sessionStore((state) => state.updateProfile);

  return useMutation({
    mutationFn: updateTrainerProfile,
    onSuccess: (response, variables) => {
      // Update local Zustand store with the successfully saved data
      updateStoreProfile(variables.data);

      toast.success('Profile updated successfully', {
        position: 'top-right',
        style: {
          borderRadius: '8px',
          background: '#0a0b24',
          color: '#fff',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      });
    },
    onError: (error: Error) => {
      toast.error(error.message, {
        position: 'top-right',
        style: {
          borderRadius: '8px',
          background: '#0a0b24',
          color: '#fff',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      });
    },
  });
}
